var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g2, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRlDriver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
    fill: "#455A64"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 14,
    width: 10,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.948 14.86h8.081v8.866c-1.347.493-2.694.74-4.04.74-1.347 0-2.694-.247-4.04-.74v-8.867Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.948 14.86h8.081v8.866c-1.347.493-2.694.74-4.04.74-1.347 0-2.694-.247-4.04-.74v-8.867Z",
    fill: "#F5C19A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.988.475c2.64 0 5.56 3.396 6.598 6.29.004.011-.164-2.331 1.76 1.793 1.134 2.827-1.674 12.6-8.359 12.6-6.684 0-10.541-9.773-9.403-12.6l2.788-1.744C6.428 3.87 9.348.475 11.988.475Z",
    fill: "#E1A679"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.09 14.316V11.5l-1.556.704c.003.584.307.876.915.876-.175.647-.054 1.024.363 1.129.417.104.51.14.279.107ZM16.677 14.316V11.5l1.556.704c-.002.584-.307.876-.914.876.174.647.053 1.023-.363 1.128-.417.105-.51.14-.279.108Z",
    fill: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.659 12.34a1.47 1.47 0 1 0 0-2.94 1.47 1.47 0 0 0 0 2.94Z",
    fill: "#F5C19A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.659 11.71a.84.84 0 1 0 0-1.68.84.84 0 0 0 0 1.68Z",
    fill: "#E1A679"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.109 12.34a1.47 1.47 0 1 0 0-2.94 1.47 1.47 0 0 0 0 2.94Z",
    fill: "#F5C19A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.109 11.71a.84.84 0 1 0 0-1.68.84.84 0 0 0 0 1.68Z",
    fill: "#E1A679"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.884 2.575a4.881 4.881 0 0 1 4.88 4.935v7.454h-.003a4.881 4.881 0 0 1-9.755 0h-.002V7.457a4.881 4.881 0 0 1 4.799-4.881h.08Z",
    fill: "#F5C19A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.564 18.364a1.102 1.102 0 1 1-2.197-.18c.119-1.457-.065-2.48-.487-3.081-.37-.528-.987-.8-1.976-.8-.99 0-1.613.274-1.992.805-.43.605-.624 1.629-.52 3.087a1.102 1.102 0 1 1-2.198.158c-.284-3.964 1.346-6.255 4.71-6.255 3.37 0 4.983 2.298 4.66 6.266Z",
    fill: "#263238"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.884 17.413c.492 0 .892-.644.892-1.137s-.4-.682-.892-.682c-.493 0-.892.19-.892.682 0 .493.399 1.137.892 1.137Z",
    fill: "#263238"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.992 10.03h.005a.945.945 0 1 1 1.877 0h.007v2.1a.945.945 0 1 1-1.89 0v-2.1Z",
    fill: "#E57373"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.248 15.328a.315.315 0 1 1-.093-.623 5.49 5.49 0 0 1 1.55-.001.315.315 0 0 1-.084.624 4.864 4.864 0 0 0-1.373 0Z",
    fill: "#EB937D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 8,
    width: 9,
    height: 4
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.582 8.455v.003c.24-.007.513-.002.82.013 2.08.101 2.03 3.344-.159 3.236-1.394-.07-2.04-.92-1.939-2.555h-.84c.101 1.634-.545 2.486-1.94 2.555-2.188.108-2.239-3.135-.159-3.236.123-.006.24-.01.352-.013v-.003h3.865Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.582 8.455v.003c.24-.007.513-.002.82.013 2.08.101 2.03 3.344-.159 3.236-1.394-.07-2.04-.92-1.939-2.555h-.84c.101 1.634-.545 2.486-1.94 2.555-2.188.108-2.239-3.135-.159-3.236.123-.006.24-.01.352-.013v-.003h3.865Z",
    fill: "#263238"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.62 2.16.013-.001h.026c.051 0 .102.002.153.007h.006c.64.012 1.882.324 3.724.935.08.02.157.045.232.077l.09.031-.002.01c.509.257.858.792.858 1.41L16.764 8H7.037V4.604a1.57 1.57 0 0 1 1.08-1.475l-.016.006c1.77-.693 2.944-1.019 3.519-.976Z",
    fill: "#E53935"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.044 2.16.012-.001h.022c.094 0 .185.01.273.032.614.039 1.673.348 3.179.928l-.014-.005c.57.183.988.792.988 1.516V8H7.037V4.603c.01-.694.404-1.278.945-1.475l-.015.006c1.549-.693 2.574-1.019 3.077-.976Z",
    fill: "#FFEBEE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.15 5.305c.897 0 1.626-.352 1.626-.787 0-.435-.729-.788-1.627-.788s-1.627.353-1.627.788c0 .435.729.787 1.627.787Z",
    fill: "#EF9A9A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.584 6.199c2.292 0 4.316.711 5.526 1.797H5.057C6.267 6.91 8.29 6.2 10.584 6.2Z",
    fill: "#E53935"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.557 12.234a.262.262 0 1 0 0-.524.262.262 0 0 0 0 .524ZM15.557 13.074a.262.262 0 1 0 0-.525.262.262 0 0 0 0 .525ZM14.927 12.654a.262.262 0 1 0 0-.525.262.262 0 0 0 0 .525ZM8.122 12.45a.262.262 0 1 0-.018.525.262.262 0 0 0 .018-.525ZM8.108 11.61a.262.262 0 1 0-.019.525.262.262 0 0 0 .019-.525ZM8.744 12.02a.262.262 0 1 0-.018.524.262.262 0 0 0 .018-.525Z",
    fill: "#EB937D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRlDriver);
export default __webpack_public_path__ + "static/media/rl-driver.4a699af6a599bf0d86e55597663794d7.svg";
export { ForwardRef as ReactComponent };